import CallToAction from '../../../organisms/CallToAction';
import useTypeTranslation from '../../../hooks/useTypeTranslation';
import useTypeUrl from '../../../hooks/useTypeUrl';
import useQueryString from '../../../hooks/useQueryString';
import ModuleContainer from '../../../organisms/ModuleContainer';
import useZoneCustomizationProps from '../../../hooks/useZoneCustomizationProps';
import { WithButton } from '../../../withs';
import { formatRawAmount } from '@gotombola/amount';

export function StandardCallToAction2GameModule({
    game,
    buttonLabel,
    buttonTarget,
    ...rest
}: StandardCallToAction2GameModuleProps) {
    const [zprops, props] = useZoneCustomizationProps(rest);
    const { t } = useTypeTranslation('game', game);
    const qs = useQueryString().toString();
    const buyUrl = useTypeUrl('game', game, 'buy', qs);
    const isRunning = 'RUNNING' === game.status;
    const hasPresentation = !!game.presentation || !!game.description;
    const hasOrganizationPresentation = !!game.organizationPresentation;
    const hasVideo =
        game.mainVideoUrl ||
        game.mainShortVideoUrl ||
        game.mainLongVideoUrl ||
        game.organizationMainVideoUrl ||
        game.organizationMainShortVideoUrl ||
        game.organizationMainLongVideoUrl;
    const hasBadges = !!game.badges && !!game.badges.items && !!game.badges.items.length;

    if (!((hasPresentation || hasOrganizationPresentation || hasVideo || hasBadges) && isRunning)) return null;

    return (
        <ModuleContainer {...zprops}>
            <CallToAction
                {...props}
                className={'hidden sm:flex'}
                target={buttonTarget || buyUrl}
                label={
                    buttonLabel ||
                    game.mainCtaLabel ||
                    t('game_participate_price', {
                        price: formatRawAmount(game.ticketPriceAmount, game.ticketPriceCurrency),
                    })
                }
            />
        </ModuleContainer>
    );
}

export interface StandardCallToAction2GameModuleProps extends WithButton {
    game: any;
}

export default StandardCallToAction2GameModule;
